import {
    DueOut,
    DueOutFetchArgs,
    getDueOutsViews,
  } from '../../assets/ts/data/dueout/dueout'
  import useServerData from '../use-server-data'
  
  function useDueoutViews(fetchArgs, waitOnParentDependency = false) {
    const {
      data: dueouts,
      error: dueoutsError,
      fetchData: fetchDueout,
      isLoading: dueoutsAreLoading,
    } = useServerData<DueOut, DueOutFetchArgs>(
      getDueOutsViews,
      fetchArgs,
      waitOnParentDependency
    )
  
    return {
      dueouts,
      dueoutsAreLoading,
      dueoutsError,
      fetchDueout,
    }
  }
  
  export default useDueoutViews
  